import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/react-hooks';
import { gql } from 'apollo-boost';

import { Content } from '../../components/Layout/Content';
import { Column } from '../../components/Grid/Column';
import { Row } from '../../components/Grid/Row';
import ServiceReleaseCard from './components/ServiceReleaseCard';
import FavoriteIcon from '../../components/FavoriteIcon';

import { Service } from '../../types/service';

import { handleLocalStorage, isServiceInStorage } from '../../utils';

import './index.scss';

const SERVICE_QUERY = gql`
  query Service($service_name: String!) {
    service(name: $service_name){
      name
      git_url
      service_versions(count:10, branch:"master", sort_order:DESC, sort:build_time){
        service_name
        id
        build_url
        build_time
        git_sha
        artifacts{
          name
          version_string
          location
            type
        }
      }
    }
  }
`;

const ServiceReleaseDetailsPage: React.FunctionComponent = () => {

  let { service_name } = useParams();

  const { loading, error, data } =  useQuery(SERVICE_QUERY, {
    variables: { service_name }
  });

  if (loading) {
    return <p>Loading</p>
  }

  if (error) {
    return <p>Error</p>
  }

  const cleanData = {
    name: data.service.name,
    git_url: data.service.git_url,
    releases: data.service.service_versions,
  } as Service

  return (
    <Content className="service-details-page">
      <div className="service-header-container">
        <h1 className="service-header">{service_name}</h1>
        <FavoriteIcon isFavorited={service_name ? isServiceInStorage(service_name) : false} onClick={() => handleLocalStorage(service_name || "")} />
      </div>
      <Row>
        <Column width={3}>
          <h2>Releases</h2>
        </Column>
        <Column width={9}>
          {
            cleanData.releases && cleanData.releases.length && cleanData.releases.map(serviceRelease => {
              return (
                <ServiceReleaseCard release={serviceRelease} git_url={cleanData.git_url} key={serviceRelease.git_sha}/>
              )
            })
          }
        </Column>
      </Row>
    </Content>
  )
}

export default ServiceReleaseDetailsPage;